import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";

const KEY = "fba_cookie_consent";

export const CookieBanner = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const choose = (choice) => {
    localStorage.setItem(KEY, choice);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 left-0 right-0 z-[90] bg-[var(--ink)] text-[var(--page)]"
          data-testid="cookie-banner"
        >
          <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-5 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8">
            <p className="text-sm leading-relaxed opacity-90 flex-1">
              {t.cookie.text}{" "}
              <Link to="/privacy" className="underline underline-offset-2 hover:opacity-70" data-testid="cookie-privacy-link">
                {t.cookie.privacy}
              </Link>
            </p>
            <div className="flex items-center gap-3 shrink-0">
              <button
                data-testid="cookie-decline"
                onClick={() => choose("declined")}
                className="px-5 py-2.5 rounded-[3px] border border-[var(--page)]/40 text-xs font-semibold uppercase tracking-wide transition-opacity hover:opacity-70"
              >
                {t.cookie.decline}
              </button>
              <button
                data-testid="cookie-accept"
                onClick={() => choose("accepted")}
                className="px-6 py-2.5 rounded-[3px] bg-[var(--page)] text-[var(--ink)] text-xs font-semibold uppercase tracking-wide transition-opacity hover:opacity-90"
              >
                {t.cookie.accept}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
